import React from "react";

import bumeran from "../../../assets/bumeran.svg";
import computrabajo from "../../../assets/computrabajo.png";
import occ from "../../../assets/occ.png";
import elempleo from "../../../assets/elempleo.png";
import laborum from "../../../assets/laborum.svg";
import workifit from "../../../assets/workifit.png";
import zonajobs from "../../../assets/zonajobs.svg";
import buscojobs from "../../../assets/buscojobs.svg";
import epreselec from "../../../assets/epreselec.png";
import tecnoempleo from "../../../assets/tecnoempleo.svg";
import sherlockhr from "../../../assets/sherlockhr.svg";
import pandape from "../../../assets/pandape.svg";
import linkedinJobs from "../../../assets/linkedin-jobs.svg";
import linkedinFeed from "../../../assets/linkedin-feed.svg";
import indeed from "../../../assets/indeed.svg";
// import facebook from "../../../assets/facebook.svg";
// import BumeranModal from "../../Opportunity/routes/OpportunityDetails/MultipostingForm/BumeranModal";

import MultipostingModal from "./MultipostingModal";

const tprefix = "opportunity:wizard.multiposting.integrations";

// Not used yet but should
export const multipostingSocialAccounts = [
  {
    provider: "linkedin",
    name: "Linkedin",
    logo: linkedinFeed,
    country: "INT"
  }
  // {
  //   provider: "facebook",
  //   name: "Facebook",
  //   logo: facebook,
  //   country: "INT"
  // }
];

export const multipostingAccounts = [
  {
    provider: "linkedin",
    name: "Linkedin",
    logo: linkedinJobs,
    country: "INT",
    modal: () => MultipostingModal,
    connectedTo: config => ({
      name: `ID ${config.companyId}`
    }),
    config: [
      {
        name: "companyId",
        tooltip: t => (
          <>
            <p>{t(`${tprefix}.linkedin.companyIdTooltip`)}</p>
            <p>
              <a
                target="_blank"
                rel="noreferrer"
                href={t(`${tprefix}.linkedin.moreInfoUrl`)}
              >
                {t(`${tprefix}.linkedin.moreInfo`)}
              </a>
            </p>
          </>
        ),
        validation: [
          {
            required: true,
            whitespace: true,
            message: t => t("form:emptyFieldValidation")
          },
          {
            pattern: /^\d*$/i,
            message: t => t("form:onlyNumbers")
          },
          {
            min: 6,
            message: t =>
              t("form:minCharsValidation", {
                chars: 6
              })
          },
          {
            max: 9,
            message: t =>
              t("form:maxCharsValidation", {
                chars: 10
              })
          }
        ]
      }
    ]
  },
  {
    provider: "indeed",
    name: "Indeed",
    logo: indeed,
    country: "INT",
    modal: () => MultipostingModal,
    connectedTo: config => ({
      name: config.companyName
    }),
    config: [
      {
        name: "companyName",
        tooltip: t => t(`${tprefix}.indeed.companyNameTooltip`),
        validation: [
          {
            required: true,
            whitespace: true,
            message: t => t("form:emptyFieldValidation")
          }
        ]
      },
      {
        name: "userEmail",
        tooltip: t => t(`${tprefix}.indeed.userEmailTooltip`),
        validation: [
          {
            required: true,
            whitespace: true,
            message: t => t("form:emptyFieldValidation")
          },
          {
            type: "email",
            message: t => t("form:validEmail")
          }
        ]
      }
    ]
  }
  // {
  //   provider: "bumeran",
  //   name: "Bumeran",
  //   logo: bumeran,
  //   country: "MEX",
  //   flag:
  // "https://img.icons8.com/color/48/mexico-circular.png",
  //   modal: () => BumeranModal,
  //   connectedTo: config => ({
  //     name: `ID ${config.emp_idempresa}`
  //   })
  // }
];

export const scraperAccounts = [
  {
    provider: "computrabajo-MEX",
    name: "CompuTrabajo",
    logo: computrabajo,
    country: "MEX",
    flag: "https://img.icons8.com/color/48/mexico-circular.png"
  },
  {
    provider: "computrabajo-ARG",
    name: "CompuTrabajo",
    logo: computrabajo,
    country: "ARG",
    flag: "https://img.icons8.com/color/48/argentina-circular.png"
  },
  {
    provider: "computrabajo-COL",
    name: "CompuTrabajo",
    logo: computrabajo,
    country: "COL",
    flag: "https://img.icons8.com/color/48/colombia-circular.png"
  },
  {
    provider: "computrabajo-PER",
    name: "CompuTrabajo",
    logo: computrabajo,
    country: "PER",
    flag: "https://img.icons8.com/color/48/peru-circular.png"
  },
  {
    provider: "computrabajo-CHL",
    name: "CompuTrabajo",
    logo: computrabajo,
    country: "CHL",
    flag: "https://img.icons8.com/color/48/chile-circular.png"
  },
  {
    provider: "computrabajo-SLV",
    name: "CompuTrabajo",
    logo: computrabajo,
    country: "SLV",
    flag:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Flag_of_El_Salvador.svg/100px-Flag_of_El_Salvador.svg.png"
  },
  {
    provider: "computrabajo-GTM",
    name: "CompuTrabajo",
    logo: computrabajo,
    country: "GTM",
    flag:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Flag_of_Guatemala.svg/100px-Flag_of_Guatemala.svg.png"
  },
  // {
  //   provider: "computrabajo-ECU",
  //   name: "CompuTrabajo",
  //   logo: computrabajo,
  //   country: "ECU",
  //   flag:
  //     "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Flag_of_Ecuador.svg/100px-Flag_of_Ecuador.svg.png"
  // },
  {
    provider: "computrabajo-URY",
    name: "CompuTrabajo",
    logo: computrabajo,
    country: "URY",
    flag: "https://img.icons8.com/color/48/uruguay-circular.png"
  },
  // {
  //   provider: "computrabajo-PRY",
  //   name: "CompuTrabajo",
  //   logo: computrabajo,
  //   country: "PRY",
  //   flag:
  //     "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Flag_of_Paraguay.svg/100px-Flag_of_Paraguay.svg.png"
  // },
  {
    provider: "elempleo-COL",
    name: "Elempleo",
    logo: elempleo,
    country: "COL",
    flag: "https://img.icons8.com/color/48/colombia-circular.png"
  },
  {
    provider: "bumeran-ARG",
    name: "Bumeran",
    logo: bumeran,
    country: "ARG",
    flag: "https://img.icons8.com/color/48/argentina-circular.png"
  },
  {
    provider: "bumeran-PER",
    name: "Bumeran",
    logo: bumeran,
    country: "PER",
    flag: "https://img.icons8.com/color/48/peru-circular.png"
  },
  {
    provider: "occ-MEX",
    name: "OCC Mundial",
    logo: occ,
    country: "MEX",
    flag: "https://img.icons8.com/color/48/mexico-circular.png"
  },
  {
    provider: "laborum-CHL",
    name: "Laborum",
    logo: laborum,
    country: "CHL",
    flag: "https://img.icons8.com/color/48/chile-circular.png"
  },
  {
    provider: "workifit-URY",
    name: "Workifit",
    logo: workifit,
    country: "URY",
    flag: "https://img.icons8.com/color/48/uruguay-circular.png"
  },
  {
    provider: "workifit-ARG",
    name: "Workifit",
    logo: workifit,
    country: "ARG",
    flag: "https://img.icons8.com/color/48/argentina-circular.png"
  },
  {
    provider: "zonajobs-ARG",
    name: "ZonaJobs",
    logo: zonajobs,
    country: "ARG",
    flag: "https://img.icons8.com/color/48/argentina-circular.png"
  },
  {
    provider: "buscojobs-URY",
    name: "Buscojobs",
    logo: buscojobs,
    country: "URY",
    flag: "https://img.icons8.com/color/48/uruguay-circular.png"
  },
  {
    provider: "epreselect-ESP",
    name: "ePreselec",
    logo: epreselec,
    country: "ESP",
    flag:
      "https://img.icons8.com/external-others-iconmarket/64/external-spain-flags-others-iconmarket.png"
  },
  {
    provider: "tecnoempleo-ESP",
    name: "Tecnoempleo",
    logo: tecnoempleo,
    country: "ESP",
    flag:
      "https://img.icons8.com/external-others-iconmarket/64/external-spain-flags-others-iconmarket.png"
  },
  {
    provider: "sherlockhr-INT",
    name: "SherlockHR",
    logo: sherlockhr,
    country: "INT"
  },
  {
    provider: "pandape-INT",
    name: "Pandapé",
    logo: pandape,
    country: "INT"
  }
];
